"use strict";

import angular from "angular";
/**
 * @component nuAccountingLogo
 * O <nu-accounting-logo> è um componente que é usado para mostrar a logo da contabilidade, se não houver, mostra o nome da contabilidade
 */

import template from "./accounting-logo.component.html";
import "./accounting-logo.component.scss";

const name = "nuAccountingLogo";
const def = {
    factory: [
        function () {
            return {
                restrict: "E",
                template,
                scope: {
                    accounting: "="
                }
            };

        }
    ]
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
